import { FileCollectionGallery } from "../../../components/FileCollectionGallery.tsx";
import { useIngredient } from "../IngredientContext.tsx";

export const IngredientPhotosTab = () => {
  const { ingredient } = useIngredient();
  return <FileCollectionGallery files={ingredient.photos} />;
};
